import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ConsentStorageKeys } from '@ld.consumer-portal/models';
import { LoanSelectionService } from '@ld.consumer-portal/utils';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-review-contact-info-modal',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './review-contact-info-modal.component.html',
  styleUrl: './review-contact-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewContactInfoModalComponent {
  private readonly router = inject(Router);
  private readonly loanSelectionService = inject(LoanSelectionService);

  readonly closeModal = output<void>();

  protected readonly isVisible = signal(true);

  protected onUpdateLater(): void {
    this.markAsShown();
    this.close();
  }

  protected onContinue(): void {
    this.markAsShown();
    this.markAsConfirmed();
    this.close();
    
    const selectedLoan = this.loanSelectionService.selectedLoan();
    if (selectedLoan) {
      this.router.navigate(['/contact-information', selectedLoan.loanNumber]);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  private markAsShown(): void {
    localStorage.setItem(ConsentStorageKeys.ContactInfoReviewShown, 'true');
  }

  private markAsConfirmed(): void {
    localStorage.setItem(ConsentStorageKeys.ContactInfoReviewConfirmed, 'true');
  }

  private close(): void {
    this.isVisible.set(false);
    setTimeout(() => this.closeModal.emit(), 200);
  }
}
